import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rpp-filters" }
const _hoisted_2 = { class: "flex items-center justify-end mt-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
      class: "mt-6 bg-white border px-6 py-4"
    }, [
      _createVNode(_component_the_select, {
        placeholder: "Компания",
        "is-invalid": _ctx.state_form$.carrier_id.$error,
        "validation-errors": _ctx.state_form$.carrier_id.$errors,
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.carrier_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.carrier_id) = $event)),
        "infinite-scroll": "",
        onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany,
        class: "mt-3"
      }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "ФИО водителя",
        value: _ctx.state.driver_name,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.driver_name) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Номер телефона водителя",
        value: _ctx.state.driver_phone,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.driver_phone) = $event)),
        maska: _ctx.PHONE_NUMBER_MASK
      }, null, 8, ["value", "maska"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Дата с",
        value: _ctx.state.fromDate,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.fromDate) = $event)),
        type: "date"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Дата по",
        value: _ctx.state.toDate,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.toDate) = $event)),
        type: "date"
      }, null, 8, ["value"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_button, {
          class: "second text small mr-2",
          loading: _ctx.loading,
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" Сброс ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}